import { render, staticRenderFns } from "./container.vue?vue&type=template&id=3ba142d2&scoped=true"
import script from "./container.vue?vue&type=script&lang=ts"
export * from "./container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba142d2",
  null
  
)

export default component.exports